
export { CapitalisationModule } from './capitalisation.module';
export { CapitalisationComponent } from './capitalisation.component';
export { CapitalisationService } from './capitalisation.service';